exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".logged-out-header[data-v-0961fdf4]{margin-bottom:0}\n", ""]);
